

export const Loading = () => { 
    return { type: 'LOADING', data : {Loading : true} }
}
export const LoadingDone = () => { 
    return { type: 'LOADING', data : {Loading : false} }
}
export const Success = (m) => { 
    return { type: 'SUCCESS', data : {Message: m} }
}
export const Error = (m) => { 
    return { type: 'FAILURE', data : {Message: m}  }
}
export const Reset = () => { 
    return { type: 'RESET' }
}
export const SetSearchUserData = (m) => { 
    return { type: 'SetSearchUserData', data : m  }
}
export const EditUser = (m) => { 
    return { type: 'EditUser', data : m  }
}
export const SetUser = (m) => {
    return { type: 'SetUser', data : m }
}
export const ShowAddUser = () => {
    return { type: 'ShowAddUser' }
}
export const HideAddUser = () => {
    return { type: 'HideAddUser' }
}
export const SetCompany = (m) => {
    return { type: 'SetCompany', data : m }
}

export const EditProduct = (m) => { 
    return { type: 'EditProduct', data : m  }
}
export const GetStatus = (m) => { 
    return { type: 'GetStatus', data : m  }
}
export const LoadOrder = (m) => { 
    return { type: 'LOAD', data : m  }
}
// export const EditcompanyProduct = (m) => { 
//     return { type: 'LOAD', data : m  }
// }
export const SetCompanySearchResult = (m) => { 
    return { type: 'SetCompanySearchResult', data : m  }
}
export const SetSelectedCompany = (m) => { 
    return { type: 'SetSelectedCompany', data : m  }
}

//Open Modal for Add Company
export const ToggleAddCompany = () => { 
    return { type: 'ToggleAddCompany' }
}

//Open Modal for Add a Company
export const ShowAddCompany = () => { 
    return { type: 'ShowAddCompany' }
}
export const HideAddCompany = () => { 
    return { type: 'HideAddCompany' }
}
//Edit Company Product
export const ShowEditCompanyProduct = () => { 
    return { type: 'ShowEditCompanyProduct' }
}
export const HideEditCompanyProduct = () => { 
    return { type: 'ShowEditCompanyProduct' }
}
//Edit Company AVM credentials
export const ShowEditCompanyAVM = () => { 
    return { type: 'ShowEditCompanyAVM' }
}
export const HideEditCompanyAVM = () => { 
    return { type: 'HideEditCompanyAVM' }
}
export const ShowEditCompanyAddress = () => { 
    return { type: 'EditCompanyAddress' }
}
export const HideEditCompanyAddress = () => { 
    return { type: 'HideEditCompanyAddress' }
}


// Load Company Product related data
export const LoadAllProduct = (m) => { 
    return { type: 'LOADALLPRODUCT', data : m  }
}
export const SetCompanyProduct = (m) => { 
    return { type: 'LOADCOMPANYPRODUCT', data : m  }
}
export const SetCompanyAddress = (m) => { 
    return { type: 'LOADCOMPANYADDRESS', data : m  }
}
export const SetCompanyAVM = (m) => { 
    return { type: 'LOADCOMPANYAVM', data : m  }
}

// Deed related actions
export const LoadAllDeeds = (m) => { 
    return { type: 'LoadAllDeeds', data : m  }
}
export const ShowAddDeed = () => { 
    return { type: 'ShowAddDeed' }
}
export const HideAddDeed = () => { 
    return { type: 'HideAddDeed' }
}
export const SetDeed = (m) => { 
    return { type: 'SetDeed', data : m  }
}

// Tax related actions
export const LoadAllTaxes = (m) => { 
    return { type: 'LoadAllTaxes', data : m  }
}
export const ShowAddTax = () => { 
    return { type: 'ShowAddTax' }
}
export const HideAddTax = () => { 
    return { type: 'HideAddTax' }
}
export const SetTax = (m) => { 
    return { type: 'SetTax', data : m  }
}

// Tax Payment related actions
export const LoadAllPayments = (m) => { 
    return { type: 'LoadAllPayments', data : m  }
}
export const ShowAddTaxPayment = () => { 
    return { type: 'ShowAddTaxPayment' }
}
export const HideAddTaxPayment = () => { 
    return { type: 'HideAddTaxPayment' }
}       
export const SetTaxPayment = (m) => { 
    return { type: 'SetTaxPayment', data : m  }
}   

// Property Report related actions
export const LoadPropertyMain = (m) => { 
    return { type: 'LoadPropertyMain', data : m  }
}

// Mrtg related actions
export const LoadAllMrtgs = (m) => { 
    return { type: 'LoadAllMrtgs', data : m  }
}
export const ShowAddMrtg = () => { 
    return { type: 'ShowAddMrtg' }
}
export const HideAddMrtg = () => { 
    return { type: 'HideAddMrtg' }
}
export const SetMrtg = (m) => { 
    return { type: 'SetMrtg', data : m  }
}